import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AssetRecoveryIncident } from '../../../../types';

type CellParams = ICellRendererParams<AssetRecoveryIncident>;

@Component({
  selector: 'app-cell-asset-recovery-id',
  imports: [MatIconModule, MatTooltipModule],
  templateUrl: './cell-asset-recovery-id.component.html',
})
export class CellAssetRecoveryIdComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
